export const getBlurhashFromUrl = (url: string | undefined) => {
  if (!url) return null;
  const urlObj = new URL(url, window.location.origin);
  const hash = urlObj.searchParams.get("b");
  return hash ? decodeURIComponent(hash) : null;
};
